import {useEffect, useState} from "react";
import "./css/detail.css";
import {BackButton, Button, DetailItems} from "./../features/index";
import axios from "axios";
import {useSearchParams, useNavigate} from "react-router-dom";

const Detail = ({}) => {
    const [queryParams] = useSearchParams();
    const [candidateItems, setCandidateItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [times, setTimes] = useState(1);
    const userId = queryParams.get("user_id");
    const navigate = useNavigate();

    const handleItemSelect = (id) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    const submitItems = async () => {
        if (queryParams.get("user_id") === null) {
            // ユーザーidがなければトップページに遷移
            navigate("/top");
            return;
        }
        const requestBody = {
            preference_list: candidateItems.map((item) => ({
                item_id: item.id,
                is_like: selectedItems.includes(item.id)
            }))
        };
        try {
            await axios.post(
                "https://dots-to-code2024-back.onrender.com" + "/user/" + userId + "/preferences",
                requestBody
            )
        } catch (error) {
            console.error("エラーが発生しました:", error);
        }

        if (candidateItems.length <= 5) {
            // 5つ以下のアイテムしかない場合は回答済みページに遷移
            navigate("/finish");
        } else {
            setTimes(times + 1)
        }
    }

    useEffect(() => {
        try {
            axios.get(
                "https://dots-to-code2024-back.onrender.com" + "/items/" + userId,
            ).then(
                (response) => {
                    const res = JSON.parse(response.data);
                    setCandidateItems(res["item_list"]);
                }
            );
        } catch (error) {
            console.error("エラーが発生しました:", error);
        }
    }, [times]);
    return (
        <div className="detail section">
            <div className="detail__back__button">
                <BackButton/>
            </div>
            <div className="detail__text">欲しいものに♡をつけてください</div>
            <DetailItems data={candidateItems} handleItemSelect={handleItemSelect}/>
            <div className="detail__button">
                <Button
                    children={"次へ"}
                    onClick={() => submitItems(selectedItems)}
                ></Button>
            </div>
        </div>
    )
}


export default Detail;
